var resm_module_map = (function (resm_module_map) {
  resm_module_map.init = function () {
    var rectPadding = { top: 100, bottom: 120, left: 50, right: 50 };

    // map nodes
    var nodeTemplate = $(
      '<a href="#" data-node-popup="" data-node-cluster="" class="gptw-node fixed-scale"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 29.78"><defs><style>.node-icon-1{fill:url(#node-icon-linear-gradient);}.node-icon-2{fill:#fff;}.node-icon-3{fill:#d40511;stroke:#fff;stroke-linejoin:round;}</style><linearGradient id="node-icon-linear-gradient" x1="11.65" y1="29.82" x2="11.65" y2="27.27" gradientTransform="translate(-35.47 1.79) scale(1 .94) skewX(50.64)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#000" stop-opacity=".3"/><stop offset="1" stop-color="#000" stop-opacity="0"/></linearGradient></defs><path class="node-icon-1" d="M20.52,28.22c0-.46-4.47-.84-9.99-.84s-10,.38-10.01,.84c0,.18,.65,.34,1.76,.48h0l8.23,1.08,8.25-1.08h0c1.11-.14,1.77-.3,1.77-.48Z"/><path class="node-icon-3" d="M20.5,10.5C20.5,4.98,16.02,.5,10.5,.5S.5,4.98,.5,10.5c0,2.1,.65,4.05,1.76,5.67h0l8.24,12.93,8.24-12.93h0c1.11-1.61,1.76-3.56,1.76-5.67Z"/><circle class="node-icon-2" cx="10.5" cy="10.5" r="4.41"/></svg></a>'
    );

    var tooltipTemplate = $(
      '<div class="gptw-node-tooltip"><span></span></div>'
    );

    $.each(resmData, function (index, data) {
      var node = nodeTemplate.clone();
      node.css({ top: data.y + "px", left: data.x + "px" });
      node.attr("data-node-popup", index);
      node.attr("data-node-cluster", data.cluster);
      $("#gptw-wrapper .gptw-panzoom-wrapper .gptw-panzoom").append(node);
      // tooltip
      var tooltip = tooltipTemplate.clone();
      tooltip.find("span").text(data.popuptitle);
      node.append(tooltip);
    });

    //update panzoom fixed scale after adding nodes so they're caught.
    resm_module_panzoom.panzoom.updateFixedScaleChildren();

    // nodes click handler
    var mouseX, mouseY;
    $("#gptw-wrapper").on("mousedown", "a[data-node-popup]", function (event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
    });
    $("#gptw-wrapper").on("click", "a[data-node-popup]", function (event) {
      // detect if dragged, cancel click.
      var distX = Math.abs(event.clientX - mouseX);
      var distY = Math.abs(event.clientY - mouseY);
      var dist = Math.max(distX, distY);
      if (dist > 2) return false;

      event.preventDefault();
      var slug = $(this).attr("data-node-popup");
      populatePopup(slug);
      $.featherlight("#gptw-wrapper #gptw-node-popup", {
        variant: "chromeless",
      });
    });

    // =================================================
    // popup
    // =================================================
    function populatePopup(index) {
      var data = resmData[index];
      var popup = $("#gptw-wrapper #gptw-node-popup");
      var region = resmRegions.find(function (check) {
        return check.slug == data.region;
      });
      $("h4", popup).html(data.title);
      $(".gptw-node-popup-image img", popup).attr("src", "" + data.image);
      $(".gptw-node-popup-excerpt", popup).html(data.content);
      $("a.realtedContentCard", popup).remove();
      $("h5", popup).hide();

      if (data.urls.length > 0) {
        $("h5", popup).show();
        $.each(data.urls, function (index, val) {
          var button = $(
            '<a href="' +
              val.url +
              '" class="realtedContentCard" target="_blank"><div class="card-link-image"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="28" height="28" fill="currentColor"><path d="M26.475 34.96l-6.376 6.376a4.982 4.982 0 01-7.047 0l-6.388-6.388a4.983 4.983 0 010-7.047l11.338-11.337a4.982 4.982 0 017.047 0l4.96 4.96a1.001 1.001 0 010 1.416l-2.12 2.12-5.669-5.668a.983.983 0 00-1.39 0L9.492 30.73a.983.983 0 000 1.39l6.388 6.388a.983.983 0 001.39 0l4.942-4.943a4.977 4.977 0 004.263 1.395zm14.861-21.908l-6.388-6.388a4.982 4.982 0 00-7.047 0l-6.376 6.376a4.977 4.977 0 014.262 1.395l4.943-4.943a.983.983 0 011.39 0l6.388 6.388a.983.983 0 010 1.39L27.17 28.608a.983.983 0 01-1.39 0l-5.67-5.668-2.12 2.12a1.001 1.001 0 000 1.416l4.962 4.96a4.982 4.982 0 007.047 0L41.336 20.1a4.983 4.983 0 000-7.047z" fill="#d40511"></path></svg></div><div class="card-link-content">' +
              val.title +
              '</div><div class="card-link-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="32" height="32" fill="currentColor"><path d="M43.829 24L31.414 36.414l-2.828-2.828L36.172 26H4v-4h32.172l-7.586-7.586 2.828-2.828z" fill="#d40511"></path></svg></div></a>'
          );
          $(".gptw-node-popup-content", popup).append(button);
        });
      }
    }

    // =================================================
    // legend
    // =================================================

    var legendGroupTemplate = $(
      '<li><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class="gptw-group-icon"><defs><style>.gptw-group-icon-cls-1{fill:#d40511;}</style></defs><path class="gptw-group-icon-cls-1" d="M16,16h-4v2h4c1.1,0,2-.9,2-2v-4h-2m0-12h-4V2h4V6h2V2c0-1.1-.9-2-2-2ZM2,2H6V0H2C.9,0,0,.9,0,2V6H2m0,6H0v4c0,1.1,.9,2,2,2H6v-2H2v-4Z"/></svg><a href="#" class="has-icon link-internal" ></a></li>'
    );
    var legendTemplate = $(
      '<li><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 29.78" class="gptw-marker-icon"><defs><style>.marker-svg-cls-1{fill:url(#linear-gradient);}.marker-svg-cls-2{fill:#fff;}.marker-svg-cls-3{fill:#d40511;stroke:#fff;stroke-linejoin:round;}</style><linearGradient id="linear-gradient" x1="11.65" y1="29.82" x2="11.65" y2="27.27" gradientTransform="translate(-35.47 1.79) scale(1 .94) skewX(50.64)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#000" stop-opacity=".3"/><stop offset="1" stop-color="#000" stop-opacity="0"/></linearGradient></defs><path class="marker-svg-cls-1" d="M20.52,28.22c0-.46-4.47-.84-9.99-.84s-10,.38-10.01,.84c0,.18,.65,.34,1.76,.48h0l8.23,1.08,8.25-1.08h0c1.11-.14,1.77-.3,1.77-.48Z"/><path class="marker-svg-cls-3" d="M20.5,10.5C20.5,4.98,16.02,.5,10.5,.5S.5,4.98,.5,10.5c0,2.1,.65,4.05,1.76,5.67h0l8.24,12.93,8.24-12.93h0c1.11-1.61,1.76-3.56,1.76-5.67Z"/><circle class="marker-svg-cls-2" cx="10.5" cy="10.5" r="4.41"/></svg><a href="#" class="has-icon link-internal" ></a></li>'
    );
    var subMenuTemplate = $("<ul></ul>");

    // ====================================================================================================
    // Build Legend
    // ====================================================================================================

    $.each(resmRegions, function (index, data) {
      var legendItem = legendGroupTemplate.clone();
      legendItem.find("a").attr("data-legend-region", data.slug);
      legendItem.find("a").text(data.title);
      $("#gptw-wrapper .gptw-legend .gptw-legend-content > ul").append(
        legendItem
      );
      var subMenu = subMenuTemplate.clone();
      $.each(resmData, function (index2, data2) {
        if (data2.region !== data.slug) return true;
        var legendItem = legendTemplate.clone();
        legendItem.find("a").attr("data-legend-item", index2);
        legendItem.find("a").text(data2.title);
        subMenu.append(legendItem);
      });
      legendItem.append(subMenu);
    });

    function getMarkersForRegionRect(region) {
      var xs = 9999;
      var ys = 9999;
      var xl = 0;
      var yl = 0;
      $.each(resmData, function (index, data) {
        if (data.region == region) {
          if (data.x < xs) xs = data.x;
          if (data.y < ys) ys = data.y;
          if (data.x > xl) xl = data.x;
          if (data.y > yl) yl = data.y;
        }
      });
      rect = { x: xs, y: ys, width: xl - xs, height: yl - ys };
      return rect;
    }

    function zoomFitRegion(region) {
      var transitionSpeed = 1000;
      $.each(resmRegions, function (index, data) {
        if (data.slug == region) {
          if (data.rect) {
            resm_module_panzoom.panzoom.smoothFitRect(
              data.rect,
              rectPadding,
              transitionSpeed
            );
          } else {
            var regionMarkersRect = getMarkersForRegionRect(region);
            console.log("regionMarkersRect", regionMarkersRect);
            resm_module_panzoom.panzoom.smoothFitRect(
              regionMarkersRect,
              rectPadding,
              transitionSpeed
            );
          }
          return;
        }
      });
    }

    // ====================================================================================================
    // Legend Regions clicks
    // ====================================================================================================

    $("#gptw-wrapper .gptw-legend").on(
      "click",
      "a[data-legend-region]",
      function (event) {
        event.preventDefault();
        if (resm_module_panzoom.panzoom.isTransitioning) return;
        var slug = $(this).attr("data-legend-region");
        zoomFitRegion(slug);
        resm_module_interface.closePanel();
      }
    );

    // ====================================================================================================
    // Legend Locations clicks
    // ====================================================================================================

    $("#gptw-wrapper .gptw-legend").on(
      "click",
      "a[data-legend-item]",
      function (event) {
        event.preventDefault();
        if (resm_module_panzoom.panzoom.isTransitioning) return;
        var slug = $(this).attr("data-legend-item");
        var data = resmData[slug];
        populatePopup(slug);
        var transitionSpeed = 1000;
        resm_module_panzoom.panzoom.smoothPanToPoint(
          data.x,
          data.y,
          3,
          transitionSpeed
        );
        setTimeout(function () {
          $.featherlight("#gptw-wrapper #gptw-node-popup", {
            variant: "chromeless",
          });
        }, transitionSpeed);
        resm_module_interface.closePanel();
      }
    );

    // ====================================================================================================
    // SVG region fitting clicks
    // ====================================================================================================

    // SVG region fitting
    var mouseX, mouseY;
    $("#gptw-wrapper .gptw-panzoom svg").on(
      "mousedown",
      "> g",
      function (event) {
        mouseX = event.clientX;
        mouseY = event.clientY;
      }
    );
    $("#gptw-wrapper .gptw-panzoom svg").on("click", "> g", function (event) {
      var distX = Math.abs(event.clientX - mouseX);
      var distY = Math.abs(event.clientY - mouseY);
      var dist = Math.max(distX, distY);
      if (dist > 2) return false;

      event.preventDefault();

      // fitting markers in this area version:
      var slug = $(this).attr("id");
      zoomFitRegion(slug);
    });
  };
  return resm_module_map;
})(resm_module_map || {});
